'use client';

import { FooterTextWithIconType } from '@/components/sections/builder/elements/footer/footer/types';
import { ElementProps } from '@/components/sections/builder/types';
import { getInnerText } from '@/lib/utils';

import { ImageIcon } from 'lucide-react';
import DynamicImage from '@/components/commons/dynamic-image';

export const defaultData: FooterTextWithIconType = {
  name: 'Text with Icon',
  heading: 'Contact Us',
  columnPerRow: 2,
  contents: [
    {
      subHeading: 'Whatsapp Number',
      description: '+62 123-0000-1111',
    },
  ],
};

export default function ElementContent({ element }: ElementProps) {
  const data = (element.data || defaultData) as FooterTextWithIconType;

  return (
    <>
      <div>
        <h2
          className='mb-1 text-lg font-medium'
          dangerouslySetInnerHTML={{ __html: data.heading || '' }}
        ></h2>

        <div className='custom-grid'>
          {data.contents?.map((c, idx) => (
            <div key={idx}>
              <div className='flex h-full w-full items-start space-x-2'>
                <div className='flex h-6 w-6'>
                  {c.iconUrl ? (
                    <DynamicImage
                      src={c.iconUrl as string}
                      width={28}
                      height={28}
                      alt={`icon-${getInnerText(c.subHeading)}`}
                      className='object-cover'
                    />
                  ) : (
                    <ImageIcon className='h-6 w-6' />
                  )}
                </div>
                <div style={{ width: 'calc(100% - 24px)' }}>
                  <p
                    className='content-footer-text'
                    dangerouslySetInnerHTML={{ __html: c.subHeading || '' }}
                  ></p>
                  <p
                    className='content-footer-text'
                    dangerouslySetInnerHTML={{ __html: c.description || '' }}
                  ></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>
        {`
          .custom-grid {
            display: grid;
            grid-template-columns: repeat(${data.columnPerRow}, minmax(0, 1fr));
            column-gap: 20px;
            row-gap: 20px;
          }
        `}
      </style>
    </>
  );
}
